/* @flow */
import ClipboardTrigger from 'components/ClipboardTrigger.jsx';
import cx from 'classnames';
import ClickEventTrigger from 'components/ClickEventTrigger.jsx';
import React from 'react';
import Text from 'components/Text.jsx';
import ToastActions from 'actions/ToastActions';

import './styles/ActivityModalLink.scss';

const ActivityModalLink = React.createClass({
  propTypes: {
    link: React.PropTypes.string.isRequired,
  },

  showCopyToast() {
    ToastActions.showSuccessToast(
      'URL has been copied to your clipboard'
    );
  },

  render() {
    return (
      <ClickEventTrigger eventElementName="ActivityModalLink">
        <ClipboardTrigger
          text={this.props.link}
          onCopy={this.showCopyToast}>
          <div
            className={cx(
              'ActivityModalLink-link',
              this.props.className,
            )}>
            <Text size="large" weight="light">
              {this.props.link}
            </Text>
          </div>
        </ClipboardTrigger>
      </ClickEventTrigger>
    );
  },
});

export default ActivityModalLink;



// WEBPACK FOOTER //
// ./src/payments/components/ActivityModalLink.jsx